export default __webpack_public_path__ + "static/media/hotel_reservation_panel.f7fccee7.png";